import { WorkloadMemberEntity } from './workload-member.entity';

export class WorkloadKpiMemberPageEntity {
  public total!: number;
  public page!: number;
  public size!: number;
  public items!: WorkloadMemberEntity[];
}

export enum WorkloadKpi {
  OverCapacity = 'OverCapacity',
  Overdue = 'Overdue',
  AtRisk = 'AtRisk',
  PlannedTimeOff = 'PlannedTimeOff',
}
